import React from "react";
import styled from "styled-components";

import Graz from "../imgs/rga_graz.jpeg";
import Linz from "../imgs/rga_linz.jpeg";
import Tirol from "../imgs/rga_tirol.jpeg";
import Bratislava from "../imgs/rga_bratislava.jpg";
import Regensburg from "../imgs/rga_regensburg.jpeg";
import "./Affiliates.scss";

const Logo = styled.div`
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${ props => props.image });  
  background-position: center;
  height: 120px;
  display: block;
`;

const LogoWrapper = styled.div`
  text-align: center;
  margin-bottom: 20px;
`;

class Affiliates extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {};
  }
  componentDidMount() { }

  render()
  {
    return (
      <div className="affiliates">
        <h2 className="heading">Affiliates</h2>
        <br />
        <div className="schools">
          <LogoWrapper>
            <a href="https://www.bjjgraz.com/">
              <Logo image={Graz} />
              Roger Gracie Graz
            </a>
          </LogoWrapper>

          <LogoWrapper>
            <a href="https://www.facebook.com/Hunley-Jiu-Jitsu-133557567065598">
              <Logo image={Linz} />
              Roger Gracie Linz
            </a>
          </LogoWrapper>

          <LogoWrapper>
            <a href="https://www.facebook.com/Kaisergymtirol/">
              <Logo image={Tirol} />
              Roger Gracie Tirol
            </a>
          </LogoWrapper>

          <LogoWrapper>
            <a href="https://www.instagram.com/rga.bratislava/">
              <Logo image={Bratislava} />
              Roger Gracie Bratislava
            </a>
          </LogoWrapper>

          <LogoWrapper>
            <a href="https://www.facebook.com/MFC-Moszat-Fight-Club-391878094701373">
              <Logo image={Regensburg} />
              Roger Gracie Regensburg
            </a>
          </LogoWrapper>

        </div>
      </div>
    );
  }
}

export default Affiliates;
